import React from 'react';
import { useSelector } from 'react-redux';

import ReservedAndPastPuppiesList from 'dpl/components/BreederProfile/mobile/components/overview/ReservedAndPastPuppiesList';

import BreederProfileCurrentLittersSectionContainer from '../BreederProfileCurrentLittersSectionContainer';
import BreederProfileLittersSectionContainer from '../BreederProfileLittersSectionContainer';

export default function BreederProfileLittersAndPuppiesTabContainer() {
  const { hasCurrentLittersDesktop, hasPastPuppies } = useSelector(
    ({ server }) => server
  );

  return (
    <div className="BreederProfileLittersAndPuppiesTabContainer">
      <BreederProfileCurrentLittersSectionContainer />
      {hasPastPuppies && <ReservedAndPastPuppiesList />}
      {hasCurrentLittersDesktop && <BreederProfileLittersSectionContainer />}
    </div>
  );
}
